import { useOwnGrants } from "../components/OwnGrants";
import { createFileRoute } from "@tanstack/react-router";
import { PageHeader } from "../components/Workspace";
import { AccessRequests } from "../components/Governance";
import { AccessExplanation } from "../components/AccessExplanation";
export const Route = createFileRoute("/requests")({ component: RequestsPage });
function RequestsPage() {
  const { registerSummarySlot } = useOwnGrants();
  return (
    <>
      <PageHeader
        title="Requests"
        description="Request temporary access, review decisions and extend an approval before it expires."
      />
      <div ref={registerSummarySlot} />
      <AccessRequests />
      <details>
        <summary>Access diagnostics</summary>
        <AccessExplanation />
      </details>
    </>
  );
}
